var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddleSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1727,
    height: 250,
    viewBox: "0 0 1727 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1764 84L1682 34L1600 66L1519 36L1437 26L1355 69L1273 64L1191 36L1109 29L1028 39L946 54L864 56V0H946H1028H1109H1191H1273H1355H1437H1519H1600H1682H1764V84Z",
    fill: "#F6F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764 131L1682 101L1600 161L1519 144L1437 156L1355 124L1273 116L1191 106L1109 91L1028 131L946 124L864 139V54L946 52L1028 37L1109 27L1191 34L1273 62L1355 67L1437 24L1519 34L1600 64L1682 32L1764 82V131Z",
    fill: "#B5D7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764 154L1682 136L1600 216L1519 186L1437 189L1355 169L1273 171L1191 136L1109 126L1028 171L946 176L864 159V137L946 122L1028 129L1109 89L1191 104L1273 114L1355 122L1437 154L1519 142L1600 159L1682 99L1764 129V154Z",
    fill: "#75B3EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764 251H1682H1600H1519H1437H1355H1273H1191H1109H1028H946H864V157L946 174L1028 169L1109 124L1191 134L1273 169L1355 167L1437 187L1519 184L1600 214L1682 134L1764 152V251Z",
    fill: "#2F8DE4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_112_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-35 84L47 34L129 66L210 36L292 26L374 69L456 64L538 36L620 29L701 39L783 54L865 56V0H783H701H620H538H456H374H292H210H129H47H-35V84Z",
    fill: "#F6F9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35 131L47 101L129 161L210 144L292 156L374 124L456 116L538 106L620 91L701 131L783 124L865 139V54L783 52L701 37L620 27L538 34L456 62L374 67L292 24L210 34L129 64L47 32L-35 82V131Z",
    fill: "#B5D7F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35 154L47 136L129 216L210 186L292 189L374 169L456 171L538 136L620 126L701 171L783 176L865 159V137L783 122L701 129L620 89L538 104L456 114L374 122L292 154L210 142L129 159L47 99L-35 129V154Z",
    fill: "#75B3EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35 251H47H129H210H292H374H456H538H620H701H783H865V157L783 174L701 169L620 124L538 134L456 169L374 167L292 187L210 184L129 214L47 134L-35 152V251Z",
    fill: "#2F8DE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 863,
    height: 250,
    fill: "white",
    transform: "matrix(-1 0 0 1 1727 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_112_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 250,
    fill: "white",
    transform: "translate(-35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleSeparator);
export default __webpack_public_path__ + "static/media/middle_separator.adc4272cfb56bbebcd7eddee7fdfb942.svg";
export { ForwardRef as ReactComponent };